/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DropFollowerEntry
 */
export interface DropFollowerEntry {
    /**
     * 
     * @type {string}
     * @memberof DropFollowerEntry
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof DropFollowerEntry
     */
    displayName: string;
    /**
     * 
     * @type {string}
     * @memberof DropFollowerEntry
     */
    avatarUrl?: string;
    /**
     * 
     * @type {number}
     * @memberof DropFollowerEntry
     */
    followedAt?: number;
}

/**
 * Check if a given object implements the DropFollowerEntry interface.
 */
export function instanceOfDropFollowerEntry(value: object): value is DropFollowerEntry {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('displayName' in value) || value['displayName'] === undefined) return false;
    return true;
}

export function DropFollowerEntryFromJSON(json: any): DropFollowerEntry {
    return DropFollowerEntryFromJSONTyped(json, false);
}

export function DropFollowerEntryFromJSONTyped(json: any, ignoreDiscriminator: boolean): DropFollowerEntry {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'displayName': json['displayName'],
        'avatarUrl': json['avatarUrl'] == null ? undefined : json['avatarUrl'],
        'followedAt': json['followedAt'] == null ? undefined : json['followedAt'],
    };
}

export function DropFollowerEntryToJSON(json: any): DropFollowerEntry {
    return DropFollowerEntryToJSONTyped(json, false);
}

export function DropFollowerEntryToJSONTyped(value?: DropFollowerEntry | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'displayName': value['displayName'],
        'avatarUrl': value['avatarUrl'],
        'followedAt': value['followedAt'],
    };
}

